const experienceData = [
    {
        title: 'Senior Software Engineer',
        company: 'S-Mobile (Belgium)',
        period: 'Feb 2024 - Present',
        responsibilities: [
            'Spearheaded the design and development of Java 11+ microservices using Spring Boot and MySQL, resulting in a 20% increase in system efficiency.',
            'Automated microservice deployment to AWS EKS(Kubernetes) using Gitlab CI/CD, Docker, and ArgoCD,reducing deployment time by 40%.',
            'Developed and executed comprehensive unit and integration tests using JUnit and Cucumber, achieving 90% code coverage and a 15% reduction in bug reports.',
            'Enhanced microservice API security by implementing Spring Security and Keycloak, mitigating potential vulnerabilities and ensuring compliance with industry standards.',
            'Managed and optimized a multi-tenancy database in PostgreSQL, supporting 100+ tenants with 99.99% uptime.',
            'Resolved an average of 10 critical bugs per month in the microservice suite, improving overall system stability and user satisfaction.',
            'Designed and developed 7+ new frontend and UI features using Angular 14, resulting in a 25% improvement in user engagement metrics.',
            'Successfully migrated 3+ microservices to Spring Boot 3 and Java 21, enhancing performance by 30% and reducing technical debt.',
            'Developed and deployed 5+ AWS Lambda functions in Python, automating key processes and reducing manual intervention by 50%.',
            'Coached and mentored a cross-functional team of 8 software developers, 5 software testers and 3 devOps personnel in Agile methodology, resulting in a 20% improvement in team velocity and a 10% reduction in sprint completion time.',
            'Utilized Jira to effectively manage and track 25+ projects and workstreams, ensuring on-time delivery and adherence to project milestones. '
        ]
    },
    {
        title: 'Senior Software Engineer',
        company: 'Cellulant (Kenya)',
        period: 'July 2022 - Jan 2024',
        responsibilities: [
            ' Led the design and development of 6 Java 11+  ' +
            'microservices using Spring Boot and MySQL.'
            ,'Implemented comprehensive unit and integration tests  ' +
            'using JUnit, Wiremock, and Cucumber, achieving 85%  ' +
            'code coverage and reducing production incidents by 20%.'
            ,'Reduced UI bugs by 30% by implementing robust  ' +
            'debugging and fixing processes using Angular 12.'
            ,'Automated microservice deployment to AWS EKS using Gitlab  ' +
            'CI/CD, Docker, and ArgoCD, resulting in a 50%  ' +
            'reduction in deployment time and improved system  ' +
            'uptime.' ,'Led and mentored a team of seven developers, improving  ' +
            'team productivity by 25% and reducing code review  ' +
            'turnaround time by 15%.  \n' ,'Facilitated agile ceremonies (daily scrums, PI Planning,  ' +
            'retrospectives,  ' +
            'refinement), resulting in a 15%  ' +
            'improvement in sprint planning accuracy and team  ' +
            'collaboration.' ,'Reviewed code from junior developers, providing  ' +
            'constructive feedback that led to a 20% reduction in code  ' +
            'defects and improved code quality.' ,'Effectively managed and tracked 15+ projects and  ' +
            'workstreams using ClickUp, ensuring on-time delivery  ' +
            'and adherence to project milestones.' ,'Implemented and maintained Newrelic observability  ' +
            'dashboards, reducing Mean Time to Resolution (MTTR)  ' +
            'for production issues by 30%.' ,'Developed and maintained a robust event-driven  ' +
            'architecture using RabbitMQ, enabling asynchronous  ' +
            'communication and improving system scalability by 40%.' ,'Implemented 5+ integrations to third-party systems via  ' +
            'REST and SOAP, enabling seamless data exchange and  ' +
            'expanding the platform\'s capabilities.' ,'Implemented caching strategies using Guava and Redis,  ' +
            'improving API response times by 35% and reducing  ' +
            'database load.' ,'Generated an average of 10 adhoc SQL queries per month  ' +
            'for reporting purposes, providing valuable insights for  ' +
            'business decision-making.'
        ]
    },
    {
        title: 'Lead Software Engineer',
        company: 'Ecocash Holdings (Zimbabwe)',
        period: 'Mar 2019 - June 2022',
        responsibilities: [
            'Led the design and development of 8 Java 8+,  ' +
            'microservices using Spring Boot and MySQL.' ,' Developed 4 in-house libraries, reducing code duplication,  ' +
            'by 20% and improving development efficiency across the,  ' +
            'team.' ,' Implemented 10+ integrations to third-party systems via,  ' +
            'REST, SOAP, and SMPP, enabling seamless data,  ' +
            'exchange and expanding platform functionality.' ,' Implemented comprehensive unit and integration tests,  ' +
            'using JUnit and Cucumber, achieving 90% code coverage,  ' +
            'and reducing bug reports by 12%.' ,' Managed the deployment of 9 microservices in WebLogic,  ' +
            'application server, ensuring 99.9% uptime.' ,' Led and mentored a cross-functional team of 10+,  ' +
            'members across three geographical regions, improving,  ' +
            'team collaboration and productivity by 20%.' ,' Effectively managed and tracked 20+ projects and,  ' +
            'workstreams using Jira, ensuring on-time delivery and,  ' +
            'adherence to project milestones.' ,' Developed and maintained 3+ USSD applications, serving,  ' +
            'over 2 million users and generating significant revenue,  ' +
            'for the company.' ,' Implemented CI/CD pipelines using Jenkins 2.0, reducing,  ' +
            'deployment time by 40% and improving release,  ' +
            'frequency.' ,' Generated an average of 35 SQL queries per month on,  ' +
            'Oracle DB for troubleshooting and reporting, providing,  ' +
            'valuable,  ' +
            'insights,  ' +
            'decision-making.  ' +
            'for,  ' +
            'issue,  ' +
            'resolution,  ' +
            'and,' ,' Implemented comprehensive unit using JUnit, achieving,  ' +
            '75% code coverage and reducing production incidents by,  ' +
            '10%.' ,' Enhanced microservice API security by implementing,  ' +
            'Spring Security and Keycloak, mitigating potential,  ' +
            'vulnerabilities and ensuring compliance with industry,  ' +
            'standards.' ,' Reduced UI bugs by 25% by implementing robust,  ' +
            'debugging and fixing processes using Angular 12.' ,' Developed and maintained a robust event-driven,  ' +
            'architecture using RabbitMQ, enabling asynchronous,  ' +
            'communication and improving system scalability by 30%.'
        ]
    },
    {
        title: 'Software Engineer',
        company: 'Zimbabwe Shared Services',
        period: 'Apr 2017 - Feb 2019',
        responsibilities: [
           'Led the design and development of 10+ Java 8+  ' +
           'microservices using Spring Boot and MySQL.','Developed and maintained 5+ USSD applications, serving  ' +
           'over 2 million users and processing over 5 million  ' +
           'requests daily.','Implemented 20+ integrations to third-party systems via  ' +
           'REST, SOAP, and SMPP, enabling seamless data  ' +
           'exchange with various banking systems.','Implemented unit testing using JUnit, achieving 85%  ' +
           'code coverage and reducing integration issues by 20%.','Successfully integrated with Postilion (ISO8583),  ' +
           'FlexCube, and T24 core banking systems, ensuring  ' +
           'seamless transaction processing for over 10 banks.','Developed 5+ in-house libraries, reducing code  ' +
           'duplication by 15% and streamlining development  ' +
           'processes.','Generated 40+ adhoc SQL queries per month for  ' +
           'reporting purposes, providing valuable insights for  ' +
           'decision-making and performance monitoring.','Led research and development into 5+ new technologies  ' +
           'and frameworks, resulting in the adoption of three key  ' +
           'technologies that improved system performance by 10%.','Reduced UI bugs by 20% by implementing robust  ' +
           'debugging and fixing processes using Angular 12.  \n','Reviewed and refined a monthly average of 25 business  ' +
           'requirements, ensuring they were clear, concise, and  ' +
           'technically feasible, reducing ambiguity and improving  ' +
           'project outcomes.','Implemented CI/CD pipelines using Docker, Gitlab  ' +
           'CI/CD, and Bamboo, reducing deployment time by 50%  ' +
           'and improving release frequency.','Implemented and maintained Kibana observability  ' +
           'dashboards, reducing Mean Time to Detect (MTTD) for  ' +
           'production issues by 40%.','Led and mentored a sub-team of 4 members using Scrum,  ' +
           'improving team velocity by 20% and ensuring on-time  ' +
           'delivery of projects.','Effectively managed and tracked 25+ projects and  ' +
           'workstreams using Youtrack, ensuring adherence to  ' +
           'project timelines and milestones.','Reviewed code from junior developers, providing  ' +
           'constructive feedback that led to a 25% reduction in code  ' +
           'defects and improved overall code quality.'
        ]
    },
    {
        title: 'Software Engineer',
        company: 'Getcash (Zimbabwe)',
        period: 'Aug 2016 - Mar 2017',
        responsibilities: [
            'Led the design and development of a JEE application in ' +
            'Java 7 and MySQL, handling 10,000+ daily transactions. ','Managed the deployment of the JEE application in ' +
            'Glassfish application server, ensuring 99.8% uptime. ','Implemented 5+ integrations to third-party systems using ' +
            'PHP with Laravel, enabling seamless data exchange. ','Implemented unit testing in JUnit, achieving 80% code ' +
            'coverage and reducing bugs by 10%. ','Led a team of seven developers using Scrum, improving ' +
            'team velocity by over 25%.'
        ]
    }
];

export default experienceData;